import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Package } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({
    name: "", email: "", password: "", phone: "",
    role: params.get("role") === "partner" ? "transport_partner" : "customer",
  });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await register(form);
      toast.success("Konto erstellt!");
      nav(u.role === "transport_partner" ? "/partner" : "/dashboard");
    } catch (e) {
      setErr(apiError(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="eb-container max-w-md py-16">
      <div className="eb-card p-8 eb-fade-up">
        <div className="w-11 h-11 rounded-xl bg-[#FF5A1F] flex items-center justify-center mb-5">
          <Package className="w-6 h-6 text-white" />
        </div>
        <h1 className="font-head text-2xl font-bold mb-1">Konto erstellen</h1>
        <p className="text-sm text-slate-400 mb-6">Kostenlos registrieren und Beiladungen buchen.</p>
        <div className="flex gap-2 mb-5 p-1 rounded-lg bg-[#0B0F17] border border-slate-800">
          {[["customer","Kunde"],["transport_partner","Transportpartner"]].map(([v,l])=>(
            <button key={v} type="button" onClick={() => setForm({...form, role: v})}
              data-testid={`register-role-${v}`}
              className={`flex-1 py-2 rounded-md text-sm font-medium transition-colors ${form.role===v?"bg-[#FF5A1F] text-white":"text-slate-400"}`}>{l}</button>
          ))}
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div><label className="eb-label">Name</label>
            <input className="eb-input mt-1.5" value={form.name} required onChange={set("name")} data-testid="register-name-input" /></div>
          <div><label className="eb-label">E-Mail</label>
            <input className="eb-input mt-1.5" type="email" value={form.email} required onChange={set("email")} data-testid="register-email-input" /></div>
          <div><label className="eb-label">Telefon (optional)</label>
            <input className="eb-input mt-1.5" value={form.phone} onChange={set("phone")} data-testid="register-phone-input" /></div>
          <div><label className="eb-label">Passwort</label>
            <input className="eb-input mt-1.5" type="password" value={form.password} required minLength={6} onChange={set("password")} data-testid="register-password-input" /></div>
          {err && <div className="text-sm text-red-400" data-testid="register-error">{err}</div>}
          <button className="eb-btn-primary w-full" disabled={loading} data-testid="register-submit-btn">
            {loading ? "Erstellen…" : "Konto erstellen"}
          </button>
        </form>
        <p className="text-sm text-slate-400 mt-5 text-center">
          Bereits registriert? <Link to="/login" className="text-[#FF5A1F] hover:underline">Anmelden</Link>
        </p>
      </div>
    </div>
  );
}
